import { ToggleButtonGroupRoot } from "./components/toggle-button-group.root";
import { ToggleButtonGroupButton } from "./components/toggle-button-group.button";

/**
 * ToggleButtonGroup
 * ============================================================
 * To group multiple `Button` components together, visually and logically, representing a set of related actions.
 */
export const ToggleButtonGroup = {
  Root: ToggleButtonGroupRoot,
  Button: ToggleButtonGroupButton,
};

export {
  ToggleButtonGroupRoot as _ToggleButtonGroupRoot,
  ToggleButtonGroupButton as _ToggleButtonGroupButton,
};
